












import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class SecondCheckBox extends Vue {
  @Prop({ default: '18' })
  public width!: string;

  @Prop({ default: '18' })
  public height!: string;

  @Prop({ default: '#a7a9ac' })
  public color!: string;
}
